import React, { Component, setState, useState, useEffect } from "react";
import PaigesVinesComponent from "./components/PaigesVinesComponet";
import PropTypes from 'prop-types';


export class PaigesVinesContainer extends Component {

    constructor (props){
        super(props)
        this.state = {
            // set any states we need for the PaigesVines page
            tastingType:'Tasting Type',
            submit:'no',
        };
        this.updateTastingType = this.updateTastingType.bind(this); 
        this.updateSubmit = this.updateSubmit.bind(this);
    }

    updateTastingType(type){
    this.setState({tastingType:type});
    }

    updateSubmit(submit){
        this.setState({submit:submit});
    }

    
    render(){
        return(
            <>
        
            <PaigesVinesComponent 
                type={this.state.tastingType} updateType={this.updateTastingType}
                submit={this.state.submit} updateSubmit={this.updateSubmit}
                tab={this.props.tab} updateTab={this.props.updateTab}
            />
            </>
        )
    }
          
        
}

PaigesVinesContainer.defaultProps={

}
PaigesVinesContainer.propTypes = {
    tab: PropTypes.string,
    updateTab:PropTypes.func,
}

export default(PaigesVinesContainer);